module.exports = {"410882001":"覃怀街道","410882002":"怀庆街道","410882003":"太行街道","410882004":"沁园街道","410882100":"崇义镇","410882101":"西向镇","410882102":"西万镇","410882103":"柏香镇","410882104":"山王庄镇","410882105":"紫陵镇","410882200":"常平乡","410882201":"王召乡","410882202":"王曲乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410882.json
// module id = 1606
// module chunks = 0